<div class="text-color-primary">
  @switch (order?.execType) {
    @case ('oco') {
      {{ order.stopPrice | currency: 'EUR' : 'symbol' : quoteFormat }} / {{ order.limitPrice | currency: 'EUR' : 'symbol' : '1.2-3' }}
    }
    @case ('tsl') {
      @if (order?.latestTslStop) {
        {{ order.latestTslStop | currency: 'EUR' : 'symbol' : quoteFormat }}
      } @else {
        {{ order.stopPrice | currency: 'EUR' : 'symbol' : quoteFormat }}
      }
    }
    @default {
      {{ order | orderLimitStopOrUndefined | currency: 'EUR' : 'symbol' : quoteFormat }}
      @if (order | orderStopLimit) {
        <span>
          /
          {{ order | orderStopLimit | currency: 'EUR' : 'symbol' : quoteFormat }}</span
        >
      }
    }
  }
</div>
